import {
	STEP_CLIENT,
	STEP_CLIENT_DATA_1,
	STEP_CLIENT_DATA_2,
	STEP_INSURANCE,
	STEP_TERM_KEH,
	FORM_REVIEW_KEH,
	STEP_KPP_VEHICLE,
	// STEP_SIGNATURE,
	STEP_AGREEMENT_KEH,
} from './constants';

export const forms = [
	// vehicle data
	STEP_KPP_VEHICLE,
	// terms
	STEP_TERM_KEH,
	// client data
	STEP_CLIENT_DATA_1,
	STEP_CLIENT_DATA_2,
	// review
	FORM_REVIEW_KEH,
	// agreement
	STEP_AGREEMENT_KEH,
	// signature
	// STEP_SIGNATURE,
];

export const steps = [
	STEP_KPP_VEHICLE,
	STEP_INSURANCE,
	STEP_CLIENT,
	FORM_REVIEW_KEH,
];
